import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5532a0ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course__content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "course__span" }, "treinamento", -1))
const _hoisted_3 = { class: "course__information" }
const _hoisted_4 = { class: "course__title" }
const _hoisted_5 = { class: "course__details-content" }
const _hoisted_6 = { class: "course__details" }
const _hoisted_7 = {
  key: 0,
  class: "course__rating"
}
const _hoisted_8 = { class: "course__duration" }
const _hoisted_9 = {
  key: 0,
  class: "course__certification"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({
      backgroundImage: `linear-gradient(101.39deg, rgba(40, 55, 135, 0.38) 0%, rgba(35, 125, 174, 0.38) 98.82%), url(${_ctx.course.thumbnailURL}) !important`
    }),
    class: "course"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.course.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.course.rating)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.course.rating), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formattedDuration(_ctx.course.duration)), 1)
          ])
        ]),
        (_ctx.course.haveCertification)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ])
  ], 4))
}